import React from 'react';


/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const view = () => {

    return(
        <div className="container-page">

            <div id="target"></div>

        </div>
    );
};

export default view;
